// extracted by mini-css-extract-plugin
export default {"root":"Results_root__P85fK","container":"Results_container__TUkyK","list":"Results_list__iQQmf","text":"Results_text__xKm-b","square":"Results_square__HvA9M"};